import { useContext } from "react";

import { Redirect, useParams } from "react-router-dom";

import DataLoader from "@/components/DataLoader";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { ERROR_404_URL } from "@/core/urls";
import { ViewerContext } from "@/tpo/Viewer";

import Template from "../shared/Template";
import Tests from "./Tests";
import { PATIENT_TESTS } from "./graphql";

function TestsTab() {
  const { userTestId: id } = useParams();
  const { userId } = useContext(ViewerContext);
  const { organisationId } = useOrganisationContext();

  return (
    <DataLoader
      query={PATIENT_TESTS}
      variables={{
        userId,
        userTestId: id,
        allTests: true,
        includeUnapproved: true,
        organisationId
      }}
      skip={!organisationId}
      render={({ userTests, userTest, ordersInProgress }) =>
        userTest ? (
          <ViewerContext.Provider
            value={{
              userId
            }}
          >
            <Tests ordersInProgress={ordersInProgress} userTests={userTests} userTest={userTest} />
          </ViewerContext.Provider>
        ) : (
          <Redirect to={ERROR_404_URL} />
        )
      }
    />
  );
}

export default function Test({ templateProps }) {
  return (
    <Template selectedTab="tests" docTitle="Patient's Tests" {...templateProps}>
      <TestsTab />
    </Template>
  );
}
